import React, { useEffect, useState } from 'react';
import type { CachedRecipe } from '@recipe-rack/shared';
import { subscribeTrending } from '@recipe-rack/shared';

import { db } from '../Recipe/Firebase/InitialiseFirebase';
import TrendingCard from './TrendingCard';

interface TrendingRowProps {
  /** Called when the user clicks "Save to my rack" on a card. */
  onSave: (cached: CachedRecipe) => void;
}

const TRENDING_LIMIT = 8;

const TrendingRow: React.FC<TrendingRowProps> = ({ onSave }) => {
  const [items, setItems] = useState<CachedRecipe[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeTrending(db, TRENDING_LIMIT, (data) => {
      setItems(data);
      setLoaded(true);
    });
    return () => unsubscribe();
  }, []);

  // Hide entirely until loaded + we have at least one cached recipe.
  // Trending should never render as an empty placeholder — it should feel
  // earned, like a chapter heading that appears when there's something
  // under it.
  if (!loaded || items.length === 0) return null;

  return (
    <section className="rr-trending" aria-label="Trending recipes">
      <header className="rr-trending-head">
        <span className="rr-rackrow-dot" aria-hidden="true" />
        <h2 className="rr-trending-title">Trending</h2>
        <span className="rr-trending-count">{items.length}</span>
      </header>
      <div className="rr-trending-scroll hide-scrollbar">
        {items.map((cached) => (
          <TrendingCard
            key={cached.urlHash}
            cached={cached}
            onSave={() => onSave(cached)}
          />
        ))}
      </div>
    </section>
  );
};

export default TrendingRow;
